interface StatCardProps {
  label: string;
  value: string;
  sub?: string;
  /** Use the accent color for the value (e.g. inventory value, live count). */
  accent?: boolean;
  positive?: boolean;
  negative?: boolean;
  onClick?: () => void;
}

export function StatCard({
  label,
  value,
  sub,
  accent,
  positive,
  negative,
  onClick,
}: StatCardProps) {
  const valueClass = positive
    ? "text-green-500"
    : negative
      ? "text-destructive"
      : accent
        ? "text-primary"
        : "text-foreground";
  const borderClass = onClick
    ? "border-primary/60 hover:border-primary"
    : "border-border";

  const content = (
    <div
      className={`flex h-full flex-col gap-1 rounded-md border bg-card p-3.5 ${borderClass}`}
    >
      <div className="text-[11px] font-medium tracking-wide text-muted-foreground">
        {label}
      </div>
      <div className={`truncate text-xl font-semibold ${valueClass}`}>
        {value}
      </div>
      {sub && <div className="text-[11px] text-muted-foreground">{sub}</div>}
    </div>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className="w-full text-left">
        {content}
      </button>
    );
  }
  return content;
}
